// Top landing pages from the GA4 traffic report: where organic and
// referred visitors actually arrive, with engagement quality.

import { Card, Eyebrow } from '../ui';

export default function LandingPagesCard({ traffic }) {
  const data = traffic?.data;
  const unavailable = !data || data.configured === false;
  const pages = data?.landingPages || [];

  return (
    <Card lash="sky" className="p-4">
      <Eyebrow className="mb-3">Top landing pages</Eyebrow>

      {traffic?.loading && <div className="text-[12px] text-ink-3">Loading GA4…</div>}
      {!traffic?.loading && unavailable && (
        <div className="text-[12px] text-ink-2">GA4 traffic unavailable.</div>
      )}
      {!traffic?.loading && !unavailable && pages.length === 0 && (
        <div className="text-[12px] text-ink-2">No landing page data in this range.</div>
      )}

      {!traffic?.loading && pages.length > 0 && (
        <div>
          <div className="flex items-center gap-3 text-[9px] font-black uppercase tracking-[0.08em] text-ink-3 pb-1 mb-1 border-b border-line-2">
            <div className="flex-1 min-w-0">Page</div>
            <div className="w-16 text-right">Sessions</div>
            <div className="w-14 text-right">Users</div>
            <div className="w-16 text-right">Engaged</div>
          </div>
          <div className="space-y-1">
            {pages.map((p, i) => (
              <div key={p.page + i} className="flex items-center gap-3 text-[12px]">
                <div className="flex-1 min-w-0 truncate font-mono text-[11px] text-navy" title={p.page}>
                  {p.page}
                </div>
                <div className="w-16 text-right tabular-nums text-ink-2">{p.sessions.toLocaleString()}</div>
                <div className="w-14 text-right tabular-nums text-ink-2">{p.users.toLocaleString()}</div>
                <div className="w-16 text-right tabular-nums text-ink-2">{(p.engagementRate * 100).toFixed(0)}%</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
}
